<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M3.6129 17.7903L3.70711 17.7071L10 11.415L13.2929 14.7071C13.6534 15.0676 14.2206 15.0953 14.6129 14.7903L14.7071 14.7071L19 10.415L20.2929 11.7071C20.8955 12.3097 21.9072 11.9277 21.994 11.1136L22 11L21.9983 6.94062L21.9893 6.85305L21.9643 6.73416L21.9401 6.65833L21.9063 6.57678L21.854 6.47929L21.7871 6.38298L21.7071 6.29286C21.6717 6.2575 21.6343 6.22531 21.5953 6.19633L21.4841 6.12467L21.3713 6.07123L21.266 6.03585L21.1485 6.01102L21.0893 6.00397L21 6H17C16.1478 6 15.7026 6.98551 16.2168 7.62253L16.2929 7.70711L17.585 9L14 12.585L10.7071 9.29289C10.3466 8.93241 9.77939 8.90468 9.3871 9.2097L9.29289 9.29289L2.29289 16.2929C1.90237 16.6834 1.90237 17.3166 2.29289 17.7071C2.65338 18.0676 3.22061 18.0953 3.6129 17.7903Z"
    fill="currentColor"
  />
</svg>
